import { fetchDocumentUrl, fetchDocumentWebUrl } from "../../api/document/Documents";

export function openDocumentById(id: string) {
  fetchDocumentUrl(id).then((obj) => {
    openDocument(obj.url);
  });
}

export function openDocument(url: string) {
  Word.run(async (context) => {
    context.application.openDocument(url);
  }).catch((err) => {
    console.debug("Error in cancel: ", err);
  });
}

export async function openFileExcel(id: string) {
  const obj = await fetchDocumentWebUrl(id);
  window.open(obj.url);
}
